export enum EntityStoreKey {
  questionsTemplates = 'questionsTemplates',
}
